/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitPalAuthSubmissionRequest
 */
export interface SubmitPalAuthSubmissionRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    submission_form_data?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    upload_to_platform?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    include_lead_summary_report?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    comment?: string;
    /**
     * Override the submission mode at submit time. Currently only 'hospital_initiated' is accepted, and only when the row is fresh (submission_mode=pending and form_id=null).
     * @type {string}
     * @memberof SubmitPalAuthSubmissionRequest
     */
    submission_mode?: SubmitPalAuthSubmissionRequestSubmissionModeEnum;
}


/**
 * @export
 */
export const SubmitPalAuthSubmissionRequestSubmissionModeEnum = {
    HospitalInitiated: 'hospital_initiated'
} as const;
export type SubmitPalAuthSubmissionRequestSubmissionModeEnum = typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum[keyof typeof SubmitPalAuthSubmissionRequestSubmissionModeEnum];


/**
 * Check if a given object implements the SubmitPalAuthSubmissionRequest interface.
 */
export function instanceOfSubmitPalAuthSubmissionRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SubmitPalAuthSubmissionRequestFromJSON(json: any): SubmitPalAuthSubmissionRequest {
    return SubmitPalAuthSubmissionRequestFromJSONTyped(json, false);
}

export function SubmitPalAuthSubmissionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitPalAuthSubmissionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'submission_form_data': !exists(json, 'submission_form_data') ? undefined : json['submission_form_data'],
        'upload_to_platform': !exists(json, 'upload_to_platform') ? undefined : json['upload_to_platform'],
        'include_lead_summary_report': !exists(json, 'include_lead_summary_report') ? undefined : json['include_lead_summary_report'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'submission_mode': !exists(json, 'submission_mode') ? undefined : json['submission_mode'],
    };
}

export function SubmitPalAuthSubmissionRequestToJSON(value?: SubmitPalAuthSubmissionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'submission_form_data': value.submission_form_data,
        'upload_to_platform': value.upload_to_platform,
        'include_lead_summary_report': value.include_lead_summary_report,
        'comment': value.comment,
        'submission_mode': value.submission_mode,
    };
}

